import { ModelPath } from "@com.mgmtp.a12.base/base-model-api/lib/main/model";
import { FormModel } from "@com.mgmtp.a12.formengine/formengine-core/lib/models";
import { EntityInstancePath } from "@com.mgmtp.a12.kernel/kernel-md-facade";

import { DisplayType, resolveDisplayType } from "../../../utilities/AnnotationHelper";
import { findCellAnnotationValue } from "../../../utilities/modelHelpers";
import { getValueFromEntityInstancePath, mergedPaths } from "../../../utilities/pathHelpers";
import { STRIKETHROUGH_DEPENDENT_FIELD } from "../../../utilities/variables/modulfRuntimeAnnotations";

/**
 * Ein per {@link STRIKETHROUGH_DEPENDENT_FIELD} annotiertes Feld wird durchgestrichen dargestellt,
 * sobald das referenzierte Feld ausgeblendet ist (d.h. es hat den Wert des Controls übernommen)
 * und dessen Wert vom angezeigten Wert abweicht.
 *
 * <p>Die Annotation kann statt am (ggf. per `modulf_replaceNode` ersetzten) Control auch an der
 * umgebenden Row liegen, siehe {@link findCellAnnotationValue}.
 */
export function isStrikethroughControl(
	formModel: FormModel | undefined,
	rowPath: ModelPath,
	cell: FormModel.CellType,
	document: { readonly [key: string]: any | undefined },
	screenPath: EntityInstancePath,
	documentPath: EntityInstancePath
): boolean {
	const annotationValue = formModel
		? findCellAnnotationValue(formModel, rowPath, cell, STRIKETHROUGH_DEPENDENT_FIELD)
		: undefined;
	if (!annotationValue) {
		return false;
	}
	if (resolveDisplayType(document as object, screenPath, annotationValue) !== DisplayType.HIDE) {
		return false;
	}

	const dependentValue = getValueFromEntityInstancePath(
		mergedPaths(ModelPath.fromString(annotationValue).slice(1), screenPath),
		document
	);
	return dependentValue !== getValueFromEntityInstancePath(documentPath, document);
}
